import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tiny-alert',
  templateUrl: './tiny-alert.component.html',
  styleUrls: ['./tiny-alert.component.scss']
})
export class TinyAlertComponent {
  @Input() isProcessed = 'success';
  @Input() message = '';
}
